module.exports = __webpack_public_path__ + "img/insurance_banner.4e759007.png";